import React, { useContext, useState } from "react";
import moment from "moment";
import { Row, Col, Badge, Select, Form, } from "antd";
import { Spin, Modal, message } from "antd";
import {
  dateInDetail,
  getFirstDate,
  getLastDate,
  getMySqlDate,
  isDateBetweenTwoDates,
  momentDate,
} from "utils/Date";
import COLORS from "common/Colors";
import UpcomingHolidays from "organisms/UpcomingHolidays";
import LeaveForm from "organisms/LeaveForm";
import { CALL_API } from "common/API";
import {
  getAllDepartmentList,
  getUserRoleId,
  getSelectedDepartmentId,
  getUserInfo,
  getClientid,
  getMenuList,
  getLeaveCategoryList,
  getUserList,
  getRoleList,
} from "redux/selectors";
import {
  concat,
  debounce,
  filter,
  find,
  first,
  get,
  includes,
  map,
  some,
} from "lodash";
import { getAllSubordinates, STATUS_CODE } from "common/Constants";
import LeaveList from "organisms/LeaveList";
import TabsList from "molecules/TabsList";
import {
  SmallCalendar,
  StyledAntCalendarFull,
  StyledAntCalendarSmall,
  StyledDateCell,
  StyleDepartmentDropdown,
  StyledHolidayBadge,
  StyledLeaveCount,
  StyledLeaveText,
  StyledLeftPanel,
  StyledNextIcon,
  StyledPreviousIcon,
  StyledTitle,
  StyledUpcomingHolidaysContainer,
} from "./StyledComponents";
import { CalendarContext } from ".";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import StaffLeaveIndicatorInCalendar from "./StaffLeaveIndicatorInCalendar";
import ReusableCalendar from "./ReusableCalendar";
import LeaveWeekCalendar from "pages/WeekCalendarView/LeaveWeekCalendar";
import { getLoadingRoute, getCountryList } from "redux/selectors";
import { uniqBy } from "lodash";
import { connect, useSelector } from "react-redux";
// ── NEW: shared filled/outlined buttons used for the cancel-leave confirmation modal ──
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";

function LeaveCalendar({
  userRoleId,
  selectedDepartmentId,
  allDepartmentList,
  userInfo,
  ClientId,
  leaveCategoryList,
  menuList,
  userList,
  roleList,
  setTabId,
  tabId,
}) {
  const {
    tabBarExtraContent,
    miniCalendarCurrentDate,
    holidayList,
    allHolidayList,
    previousMonth,
    nextMonth,
    calendarView,
    setCalendarView,
  } = useContext(CalendarContext);

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  let tabMenus = Menulist.filter(
    (item) =>
      item.key === "mycalendar" ||
      item.key === "teamcalendar" ||
      item.key === "allcalendar"
  );

  let newArray = [];
  newArray.push(...tabMenus);

  const items =
    newArray &&
    newArray
      ?.filter((data) => data.access === true)
      .map((data, index) => ({
        id: data.subtitle,
        label: data.subtitle,
        component: <></>,
      }));

  const [departmentSelectedByHR, setDepartmentSelectedByHR] = useState("");
  const [leaveListFiterForHR, setLeaveListFiterForHR] = useState({});
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo.userid
  );
  const [displayLeaveModal, toggleLeaveModal] = useState(false);
  const [isLeaveListModalVisible, toggleLeaveListModalVisible] =
    useState(false);
  const [leaveDetails, setLeaveDetails] = useState({});
  const [showMyTeamLeaves, toggleMyTeamLeave] = useState(false);
  const countryList = useSelector(getCountryList)
  const [form] = Form.useForm();
  const [selectedManagingOffice, setSelectedManagingOffice] = useState(filteruser[0]?.managingoffice);

  // ── NEW: custom "Cancel Leave" confirmation modal state.
  // Replaces Modal.confirm's okText/cancelText (plain antd buttons) so the
  // Yes / No actions can be rendered with ButtonFilled / ButtonOutlined. ──
  const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false);
  const [recordPendingCancel, setRecordPendingCancel] = useState(null);
  const [cancelingLeave, setCancelingLeave] = useState(false);

  moment.updateLocale("en", {
    weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
  });

  const handleTabSelect = (key) => {
    const activeTab = items.find((item) => item.id === key);
    if (activeTab) {
      setTabId(activeTab.label);
    }

    if (key === 0) {
      toggleMyTeamLeave(!showMyTeamLeaves);
    }
  };

  const country = tabId === "My Team"
    ? "" : selectedManagingOffice ? selectedManagingOffice : [];

  let payload = {
    status_id: "4,5",
    officesupervisorid: tabId === "My Team" ? filteruser[0]?.employeeid : [""],
    start_date: getFirstDate(miniCalendarCurrentDate),
    end_date: getLastDate(miniCalendarCurrentDate),
    show_my_team_leave: tabId === "My Team" ? true : false,
    country,
  };

  const { key, url } = queryKeys.getLeaveList(ClientId, JSON.stringify(payload));

  const { data: leaveDataRes, isLoading: displayLoader, refetch: getLeaveList } = useFetch(
    key,
    url,
    { enabled: !!ClientId },
    payload
  );

  const leaveList = leaveDataRes?.response?.leaves?.filter(
    (val) => val?.userid === get(userInfo, "userid", "")
  );

  const myTeamLeaveList = leaveDataRes?.response?.teamLeaves

  const allLeaveList = leaveDataRes?.response?.leaves?.filter((val) => {
    return val;
  });

  const addLeave = (event, cellDate) => {
    if (
      userRoleId != 1 &&
      event.target.className === "ant-picker-calendar-date-content"
    ) {
      const isPastDate =
        moment(getMySqlDate(cellDate)) < moment(getMySqlDate("2022-08-01"));
      if (!isPastDate) {
        toggleLeaveModal(true);
        setLeaveDetails({
          start_date: cellDate,
          end_date: cellDate,
        });
      }
    }
  };

  const handleFormChange = (value) => {
    setSelectedManagingOffice(value);
  };

  const AllTabID =
    tabId === "All" && items?.find((item) => item.id === "All") ? true : false;

  const MYTabID =
    tabId === "Mine" && items?.find((item) => item.id === "Mine")
      ? true
      : false;

  const MYTEAMTabID =
    tabId === "My Team" && items?.find((item) => item.id === "My Team")
      ? true
      : false;

  const dateFullCellRender = (cellDate) => {
    const { date: day, day: Days } = dateInDetail(cellDate);
    const leave = filter(
      leaveList,
      ({ start_date, new_start_date, new_end_date, end_date, status_id }) =>
        includes(["4", "5"], status_id) &&
        isDateBetweenTwoDates(
          cellDate,
          new_start_date === "null" ||
            new_start_date === null ||
            new_start_date === ""
            ? start_date
            : new_start_date,
          new_end_date === "null" ||
            new_end_date === null ||
            new_end_date === ""
            ? end_date
            : new_end_date
        ),
      {}
    );

    const teamLeave =
      (AllTabID || MYTEAMTabID) &&
      filter(
        myTeamLeaveList,
        ({ start_date, new_start_date, new_end_date, end_date, status_id }) =>
          includes(["4", "5"], status_id) &&
          isDateBetweenTwoDates(
            cellDate,
            new_start_date === "null" ||
              new_start_date === "" ||
              new_start_date === null
              ? start_date
              : new_start_date,
            new_end_date === "null" ||
              new_end_date === "" ||
              new_end_date === null
              ? end_date
              : new_end_date
          ),

        {}
      );

    const leaveDetails = first(MYTabID ? leave : teamLeave);
    const filterleavetype = leaveCategoryList?.filter(
      (item) => item.leave_category_id === leaveDetails?.leave_category_id
    );
    const holidayrequired = filterleavetype[0]?.holiday;
    const weekendrequired = filterleavetype[0]?.weekend;
    const isSaturdayrequired = filterleavetype[0]?.isSaturday;
    const statusId = get(leaveDetails, "status_id", "");
    const havingcancelrequest = get(leaveDetails, "having_cancel_request", "");
    const isHoliday = find(
      MYTabID ? holidayList : allHolidayList,
      ({ start_date, end_date }) =>
        isDateBetweenTwoDates(cellDate, start_date, end_date)
    );
    const leaveType =
      statusId === "4" &&
        (weekendrequired === "Yes" ? Days : Days !== "Sunday") &&
        (isSaturdayrequired === "Yes" ? Days : Days !== "Saturday") &&
        (holidayrequired === "Yes" || MYTEAMTabID ? Days : !isHoliday)
        ? "has-pending-leaves"
        : havingcancelrequest === "1" &&
          (weekendrequired === "Yes" ? Days : Days !== "Sunday") &&
          (isSaturdayrequired === "Yes" ? Days : Days !== "Saturday") &&
          (holidayrequired === "Yes" || MYTEAMTabID ? Days : !isHoliday)
          ? "has-pending-leaves"
          : statusId === "5" &&
            (weekendrequired === "Yes" ? Days : Days !== "Sunday") &&
            (isSaturdayrequired === "Yes" ? Days : Days !== "Saturday") &&
            (holidayrequired === "Yes" || MYTEAMTabID ? Days : !isHoliday)
            ? "has-approved-leaves"
            : "";

    const leaveColor = get(isHoliday, "color", "");
    const hrPendingLeaves = filter(
      allLeaveList,
      ({
        start_date,
        end_date,
        status_id,
        having_cancel_request,
        new_start_date,
        new_end_date,
      }) =>
        (status_id === "4" &&
          isDateBetweenTwoDates(cellDate, start_date, end_date)) ||
        (status_id === "5" &&
          having_cancel_request === "1" &&
          isDateBetweenTwoDates(cellDate, new_start_date, new_end_date)),
      {}
    ).length;

    const hrApprovedLeaves = filter(
      allLeaveList,
      ({ start_date, end_date, status_id, having_cancel_request }) =>
        status_id === "5" &&
        (having_cancel_request === "0" || having_cancel_request === "") &&
        isDateBetweenTwoDates(cellDate, start_date, end_date),
      {}
    ).length;

    return (
      <>
        {MYTabID && (
          <StyledDateCell
            onClick={(event) =>
              Menulist?.find(
                (item) => item?.key === "mycalendar" && item?.permission?.create
              )
                ? addLeave(event, cellDate)
                : ""
            }
          >
            <span className={`day ${leaveType}`}>
              {leaveColor && (
                <StyledHolidayBadge
                  status="success"
                  size="small"
                  color={leaveColor}
                >
                  H
                </StyledHolidayBadge>
              )}
              {leaveType &&
                MYTabID &&
                map(leave, (leaveDetails) => (
                  <StaffLeaveIndicatorInCalendar
                    icon="team"
                    leaveDetails={leaveDetails}
                    isStaff={true}
                    day={day}
                    openEditLeaveModal={(details) => {
                      cancelLeaveRequest(details);
                    }}
                    EditLeaveModal={(details) => {
                      cancelLeave(details);
                    }}
                  >
                    {day}
                  </StaffLeaveIndicatorInCalendar>
                ))}
              {!leaveType && day}
            </span>
            <div className="ant-picker-calendar-date-content"></div>
          </StyledDateCell>
        )}

        {MYTEAMTabID && (
          <StyledDateCell>
            <b>{day}</b>
            {leaveColor && (
              <StyledHolidayBadge
                status="success"
                size="small"
                color={leaveColor}
              >
                H
              </StyledHolidayBadge>
            )}
            <div className="ant-picker-calendar-date-content">
              {leaveType &&
                MYTEAMTabID &&
                map(teamLeave, (leaveDetails) => (
                  <StaffLeaveIndicatorInCalendar
                    key={leaveDetails.user_leave_id}
                    icon="team"
                    leaveDetails={leaveDetails}
                    isStaff={false}
                    reloadList={getLeaveList}
                    openEditLeaveModal={() => {
                      setLeaveDetails(leaveDetails);
                      toggleLeaveModal(true);
                    }}
                    EditLeaveModal={() => {
                      setLeaveDetails(leaveDetails);
                      toggleLeaveModal(true);
                    }}
                    displayLeaveDetail={AllTabID ? true : false}
                    Days={Days}
                  />
                ))}
            </div>
          </StyledDateCell>
        )}

        {AllTabID && (
          <StyledDateCell>
            <b>{day}</b>
            {leaveColor && (
              <StyledHolidayBadge
                status="success"
                size="small"
                color={leaveColor}
              >
                H
              </StyledHolidayBadge>
            )}
            <div className="ant-picker-calendar-date-content">
              {AllTabID && (
                <>
                  <div className="hr-leave-container">
                    <Badge
                      count={hrPendingLeaves}
                      className="hr-has-pending-leaves"
                      onClick={() => {
                        setLeaveListFiterForHR({
                          date: cellDate,
                          status_id: "4",
                        });
                        toggleLeaveListModalVisible(true);
                      }}
                    />
                    <Badge
                      count={hrApprovedLeaves}
                      className="hr-has-approved-leaves"
                      onClick={() => {
                        setLeaveListFiterForHR({
                          date: cellDate,
                          status_id: "5",
                        });
                        toggleLeaveListModalVisible(true);
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </StyledDateCell>
        )}
      </>
    );
  };

  // ── NEW: opens the custom Yes/No confirmation modal, stashing the record
  // that should be cancelled once the user confirms. ──
  const openCancelConfirm = (details) => {
    setRecordPendingCancel(details);
    setCancelConfirmOpen(true);
  };

  // ── NEW: performs the actual cancellation once "Yes" is pressed.
  // Same payload/logic previously duplicated inside cancelLeaveRequest and
  // cancelLeave's Modal.confirm onOk handlers, hitting the same
  // approve-reject-cancel-leave endpoint. ──
  const confirmCancelLeave = async () => {
    const details = recordPendingCancel;
    if (!details) return;
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      userid,
    } = details;
    try {
      setCancelingLeave(true);
      const { code } = await CALL_API(
        `approve-reject-cancel-leave/${ClientId}`,
        "post",
        {
          user_leave_id,
          status_id: "9",
          is_cancel_request: false,
          start_date: getMySqlDate(leave_start_date),
          end_date: getMySqlDate(leave_end_date),
          leave_applied_userid: userid,
        }
      );
      if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
        message.error(`Oops!! something went wrong.`);
      } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
        message.error(`Invalid payload. Please enter correct data.`);
      } else if (code === STATUS_CODE.RECORD_EXIST) {
        message.error(`Leave aleady exist.`);
      } else if (code === STATUS_CODE.SUCCESS) {
        message.success(`Your leave application has been cancelled.`);
        getLeaveList();
      }
    } catch (err) {
      console.log("[confirmCancelLeave] Error -->", err);
    } finally {
      setCancelingLeave(false);
      setCancelConfirmOpen(false);
      setRecordPendingCancel(null);
    }
  };

  // ── UPDATED: now opens the custom confirmation modal instead of Modal.confirm ──
  const cancelLeaveRequest = (details) => {
    const { status_id } = details;
    if (userRoleId !== 1 && status_id !== "4") {
      openCancelConfirm(details);
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  };

  // ── UPDATED: now opens the custom confirmation modal instead of Modal.confirm ──
  const cancelLeave = (details) => {
    const { status_id } = details;
    if (userRoleId !== 1 && status_id === "4") {
      openCancelConfirm(details);
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  };

  const leaveCalendarContent = (
    <>
      <Row gutter={20}>
        <Col span={4}>
          <StyledLeaveCount color={COLORS.PENDING_LEAVE} />
        </Col>
        <Col span={20}>
          <StyledLeaveText>
            Pending Leaves{includes([1, 4], userRoleId) ? "" : " count"}
          </StyledLeaveText>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={4}>
          <StyledLeaveCount color={COLORS.APPROVED_LEAVE} />
        </Col>
        <Col span={20}>
          <StyledLeaveText>
            Approved Leaves{includes([1, 4], userRoleId) ? "" : " count"}
          </StyledLeaveText>
        </Col>
      </Row>
    </>
  );

  const uniquemanagingOffice = uniqBy(
    countryList?.map((item) => {
      return { label: item?.countryname, value: item?.countryname };
    }),
    "value"
  );

  // Country filter select, now passed into ReusableCalendar so it can be
  // rendered inline with the month navigation instead of stacking above it.
  const countryFilterSelect = AllTabID && (
    <Select
      showSearch
      options={uniquemanagingOffice}
      placeholder="Select Country"
      labelInValue
      style={{ width: 200 }}
      value={
        selectedManagingOffice
          ? { label: selectedManagingOffice, value: selectedManagingOffice }
          : undefined
      }
      onChange={(option) => {
        handleFormChange(option?.value || "");
      }}
    />
  );

  return (
    <>
      <TabsList
        items={items}
        handleTabSelect={handleTabSelect}
        tabBarExtraContent={tabBarExtraContent}
        tabId={tabId}
      />
      {MYTabID && <LeaveWeekCalendar holidayList={holidayList} viewType={calendarView} setViewType={setCalendarView} />}
      {!MYTabID && (
        <div style={{ position: "relative" }}>
          {AllTabID && (
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                height: 40,
              }}
            >
              {countryFilterSelect}
            </div>
          )}
          <ReusableCalendar
            dateFullCellRender={dateFullCellRender}
            isCalendarLoading={displayLoader}
            calendarTitle={MYTabID ? "My Calendar" : "Calendar"}
            leftPanelContent={leaveCalendarContent}
            headerExtra={countryFilterSelect}
          />
        </div>
      )}

      <LeaveForm
        isModalVisible={displayLeaveModal}
        closeModal={() => toggleLeaveModal(false)}
        leaveDetails={leaveDetails}
        getLeaveList={getLeaveList}
      />
      <LeaveList
        isModalVisible={isLeaveListModalVisible}
        closeModal={() => toggleLeaveListModalVisible(false)}
        date={get(leaveListFiterForHR, "date", "")}
        status_id={get(leaveListFiterForHR, "status_id", "")}
        department_id={departmentSelectedByHR}
        selectedManagingOffice={selectedManagingOffice}
      />

      {/* ── NEW: "Cancel Leave" confirmation — Yes (ButtonFilled) / No (ButtonOutlined) ── */}
      <Modal
        open={cancelConfirmOpen}
        onCancel={() => { setCancelConfirmOpen(false); setRecordPendingCancel(null); }}
        footer={null}
        width={420}
        closable={false}
        centered
      >
        <div style={{ textAlign: "left", padding: "8px 4px" }}>
          <p style={{ marginBottom: 28 }}>
            Are you sure you want to cancel your leave application?
          </p>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
            <ButtonOutlined
              onClick={() => { setCancelConfirmOpen(false); setRecordPendingCancel(null); }}
              disabled={cancelingLeave}
            >
              No
            </ButtonOutlined>
            <ButtonFilled onClick={confirmCancelLeave} disabled={cancelingLeave}>
              {cancelingLeave ? "Cancelling…" : "Yes"}
            </ButtonFilled>
          </div>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  leaveCategoryList: getLeaveCategoryList(state),
  userList: getUserList(state),
  roleList: getRoleList(state),
});

export default connect(mapStateToProps, null)(LeaveCalendar);